export default "__VITE_ASSET__DZvtpMfJ__"